<template>
  <el-dialog title="以下记录未能匹配" :visible.sync="dialogVisible" width="400px">
    <div class="unmatched-text">{{ inputText }}</div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="$emit('update:visible', false)">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'UnmatchedStudentsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    inputText: {
      get() {
        return this.text
      },
      set(val) {
        this.$emit('update:text', val)
      }
    }
  }
}
</script>

<style scoped>
/* 未能匹配文本样式 */
.unmatched-text {
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>